import DropDownItem from './DropDownItem.vue';
export default DropDownItem;
